import React , { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import SettingsTabs from '../components/SettingsComponents/SettingsTabs';
import GeneralSettings from './../components/SettingsComponents/General/GeneralSettings';
import SchedulesSettings from '../components/SettingsComponents/Schedules/SchedulesSettings';
import PoiView from "../components/SettingsComponents/POI/PoiView";
import { bindActionCreators } from 'redux';
import ActionCreator from './../store/actions/index';
import { useWindowSize } from './../utils/hooks/useWindowResize';
import { countHeightWhen2HeightToolbarUsed } from './../utils/helpers';

const SettingsView = (props) => {
    const [tab, setTab] = useState(0);
    const { height } = useWindowSize();

    useEffect(() => {
        props.getContactData();
        props.getSettingsNotifications();
        props.getSettingsReminders();
        props.getOtherSettings();
        props.getSettingsMobileAppKey();
        props.getTireChange();

        props.getRegularHolidays();
        props.getMovingHolidays();
        props.getDaysOff();
        props.getSettingsWorkingHours();

        props.getPoiLocations();
        props.getTrophySettings();
    }, []);

    return (
        <div>
            <SettingsTabs value={tab} onTabChange={setTab} />
            {tab === 0 && <GeneralSettings />}
            {tab === 1 && <SchedulesSettings height={countHeightWhen2HeightToolbarUsed(height)} />}
            {tab === 2 && <PoiView height={height} />}
        </div>
    );
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

SettingsView.propTypes = {
    //redux
    getContactData: PropTypes.func,
    getSettingsNotifications: PropTypes.func,
    getSettingsReminders: PropTypes.func,
    getOtherSettings: PropTypes.func,
    getSettingsMobileAppKey: PropTypes.func,
    getTireChange: PropTypes.func,
    getRegularHolidays: PropTypes.func,
    getMovingHolidays: PropTypes.func,
    getDaysOff: PropTypes.func,
    getSettingsWorkingHours: PropTypes.func,
    getPoiLocations: PropTypes.func,
    getTrophySettings: PropTypes.func,
};

export default connect(
    null,
    mapDispatchToProps
)(SettingsView);